<div #container class="container">
  <app-flights-toolbar class="toolbar" [lastUpdatedTb]="lastUpdated"/>
  <div #flightlist id="flightlist" class="flight-list-container">
    <div class="paging-container">
      <div class="paging">
        <div class="button-row">
          <button class="chevron-btn pi pi-angle-left" (click)="getPrevPeriod()" [disabled]='dateNotAvailable()'>
          </button>
          <p-datepicker
            #calendar
            class="calendar" 
            (onSelect)="dateInputEvent($event)" 
            [(ngModel)]="date" 
            [showIcon]="false"
            dateFormat="MM yy" 
            view="month"
            [minDate]="minDate" 
            [readonlyInput]="true"
            [touchUI]="true"
            appendTo="body"
            >
            <p-footer>
              <div class="buttonbar">
                <button [dt]="calendarButton" pButton label="Today"  (click)="onTodayClick()"></button>
                <button [dt]="calendarButton" pButton label="Done"  (click)="onDoneClick()"></button>
              </div>
            </p-footer>
          </p-datepicker>
            
          <button class="chevron-btn pi pi-angle-right" (click)="getNextPeriod()" [disabled]="dateIsNow()">
          </button>
        </div>
      </div>
    </div>
    <div class="flight-list-container">
      <div class="flight-list-content" #scroll>
        <div *ngIf="activityRecordList$ | async as activityRecordList">
          @if(activityRecordList.sequences.length != 0) {
          <div *ngFor="let sequence of activityRecordList.sequences, let i = index">
            <div class="header">
              <div class="header-title" (click)="onSequenceClicked(sequence, i)">
                {{ sequence.sequenceNumber }}
              </div> 
              <div class="header-stats">
                <div class="stats-label">Days:</div>
                {{getDuration(sequence.dutyPeriodSummaries)}}
                <div class="stats-label">Total:</div>
                {{getTripFlightTime(sequence)}}
              </div>
            </div>
            <div *ngFor="let duty of sequence.dutyPeriodSummaries">
              <div #leg class="leg" *ngFor="let leg of duty.legs; let i = index" [style]="
                setBorder()">
                <app-flight-item 
                  (click)="onLegClicked(leg, sequence)"
                  [isTimeFormatUTC]="isTimeFormatUTC" 
                  [flightNumber]="leg.flightNumber" 
                  [aircraft]="leg.aircraft"
                  [depStation]="leg.departureStation.code" 
                  [arrStation]="leg.arrivalStation.code"
                  [depTimes]="leg.departure" 
                  [arrTimes]="leg.arrival" 
                  [flightTimeActual]="leg.flightTimeActual"
                  [flightTimeScheduled]="leg.flightTimeScheduled" 
                  [isDeadhead]="leg.isDeadhead"
                  [isCancelled]="leg.isCancelled">
                </app-flight-item>
              </div>
            </div>
          </div>
          }
          @else {
          <div>
            @if (dateNotAvailable()) {
            <div class="no-flights">
              APA does not have data prior to 1998</div>
            }
            @else {
              <div class="no-flights">
                No Flights Found</div>
            }
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>